import React, { useState } from 'react';

import BackButton from 'Components-redesign/BackButton';
import Select from 'Components-redesign/Fields/Select';
import Modal from 'Components-redesign/Modal';
import ModalContentWrapper from 'Components-redesign/Modal/ModalContentWrapper';
import { CURRENCIES, LANGUAGES } from 'consts';
import { useI18n } from 'Hooks';

import useModal from '../../../Components-redesign/Modal/useModal';
import { AddCompanyProps } from '../types';
import { validateFormData } from '../validationRules';
import {
  Checkbox,
  ErrorMessage,
  Form,
  InnerWrapper,
  Input,
  InputWrapper,
  InputWrapperConfirm,
  Label,
  LabelConfirm,
  PasswordHint,
  RegisterLinkWrapper,
  StepCounter,
  SubmitButton,
  TermsConditionsBtn,
  Title,
  Wrapper,
} from './styles';
import TermsAndConditions from './TermsAndConditions';

const AddCompanyView: React.FunctionComponent<AddCompanyProps> = ({
  brandName,
  language,
  currency,
  onSetField,
  onRegister,
  loading,
}) => {
  const { t } = useI18n();

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [errors, setErrors] = useState({});
  const [isShowingModal, setIsShowing] = useState(false);

  const { isShowing = false, toggle, hide } = useModal();

  const registerUser = () => {
    const errorData = validateFormData(
      {
        brandName,
        language,
        currency,
      },
      t,
    );
    setErrors(errorData);
    if (!Object.keys(errorData).length) {
      onRegister();
      setIsShowing(true);
    }
  };
  return (
    <Wrapper>
      <InnerWrapper>
        <StepCounter>{t('Register.StepSecond')}</StepCounter>
        <Title>{t('Register.TellUsMoreAboutYourBusiness')}</Title>
        <Form autoComplete="off">
          <InputWrapper>
            <Label>{t('Register.BrandName')}</Label>
            <Input
              key="brandName"
              onChange={(val) => onSetField('brandName', val.target.value)}
              type="text"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              value={brandName}
              autoFocus
            />
          </InputWrapper>
          <ErrorMessage>{errors['brandName']}</ErrorMessage>
          <InputWrapper>
            <Label>{t('Register.DefaultLanguage')}</Label>
            <Select
              name="language"
              list={LANGUAGES}
              selected={{ id: language ?? LANGUAGES[0].id }}
              handleChange={(name, value) => {
                onSetField('language', value.id);
              }}
            />
          </InputWrapper>
          <ErrorMessage>{errors['language']}</ErrorMessage>
          <InputWrapper>
            <Label>{t('Register.Currency')}</Label>
            <Select
              list={CURRENCIES}
              name="currency"
              selected={{ id: currency ?? CURRENCIES[0].id }}
              handleChange={(name, value) => {
                onSetField('currency', value.id);
              }}
            />
          </InputWrapper>
          <ErrorMessage>{errors['currency']}</ErrorMessage>
          <InputWrapperConfirm>
            <Checkbox checked={!!acceptTerms} onChange={(val) => setAcceptTerms(!acceptTerms)} />
            <LabelConfirm>
              {t('General.Confirm')}
              <TermsConditionsBtn type="button" onClick={toggle}>
                <RegisterLinkWrapper>{t('Register.TermsAndConditions')}</RegisterLinkWrapper>
              </TermsConditionsBtn>
            </LabelConfirm>
          </InputWrapperConfirm>
          <SubmitButton
            type="button"
            isLoading={loading}
            onClick={registerUser}
            disabled={!acceptTerms}>
            {loading ? (
              <>{t('General.LoadingThreeDots')}</>
            ) : (
              <span>{t('General.CreateAccount')}</span>
            )}
          </SubmitButton>
        </Form>
        <BackButton />
      </InnerWrapper>
      <Modal isShowing={isShowingModal} showCloseBtn={true} hide={() => setIsShowing(false)}>
        <ModalContentWrapper width="448px">
          <>
            <Title>{t('Register.AlmostThere')}</Title>
            <PasswordHint>{t('Register.VerifyYourAccount')}</PasswordHint>
          </>
        </ModalContentWrapper>
      </Modal>
      <TermsAndConditions isShowing={isShowing} hide={hide} />
    </Wrapper>
  );
};

export default AddCompanyView;
